var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13,
    cy: 10.7,
    r: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M6.2 22.6l6.8-6.8 6.8 6.8M13 18v15.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M6.2 22.6l6.8-6.8 6.8 6.8M13 18v15.5M36.3 10.7l-17 .1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapseAll.0e8f4327be07d7944954a321fdb65bc9.svg";
export { ForwardRef as ReactComponent };